export default "__VITE_ASSET__4d58c7df__"